import React from 'react';
import { SectionWrapper } from 'components/atoms/SectionWrapper.style';
import Slider from 'components/organisms/mainPageComponents/slider/Slider';
import WhyWe from 'components/organisms/mainPageComponents/whyWe/WhyWe';
import Gallery from 'components/organisms/mainPageComponents/gallery/Gallery';
import Contact from 'components/organisms/mainPageComponents/mainPageFooter/MainPageFooter';
import MainPageImg from 'components/organisms/mainPageComponents/mainPageImg/MainPageImg';
import styled from 'styled-components';
import { cms } from 'assets/cms';
import EleHeader from 'components/organisms/header/EleHeader';
import EleMainPageImg from 'components/organisms/mainPageComponents/mainPageImg/EleMainPageImg';
import EleSlider from 'components/organisms/mainPageComponents/slider/EleSlider';
import OzeHeader from 'components/organisms/header/OzeHeader';
import OzeMainPageImg from 'components/organisms/mainPageComponents/ozePaheImg/OzeMainPageImg';
import OzeSlider from 'components/organisms/mainPageComponents/slider/OzeSlider';

const WrapperBackground = styled.div`
  height: 100%;
  background: center url(${cms.elgreen.lisc});
  /* background-size: contain; */
`;

const OzeMainPage = () => (
  <>
    <OzeHeader />
    <OzeMainPageImg />
    <SectionWrapper>
      <OzeSlider />
    </SectionWrapper>
    <Contact />
  </>
);

export default OzeMainPage;
